import React, { useState } from 'react';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import AccurityIcon from '../../../icon/components/AccurityIcon';
import Box from '@mui/material/Box';
var DetailHeader = function (_a) {
    var _b;
    var iconName = _a.iconName, inverted = _a.inverted, title = _a.title, _c = _a.disabledScrolling, disabledScrolling = _c === void 0 ? false : _c, children = _a.children;
    var _d = useState(null), ref = _d[0], setRef = _d[1];
    // change visual whed detail is scolled
    var trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        // scrolling element must be direct parentElement
        target: (_b = ref === null || ref === void 0 ? void 0 : ref.parentElement) !== null && _b !== void 0 ? _b : undefined,
    });
    return (React.createElement(Box, { className: 'accurityDetail__header', sx: { boxShadow: trigger ? 3 : 0, backgroundColor: inverted ? undefined : 'background.paper' }, ref: disabledScrolling
            ? undefined
            : function (newRef) { return setRef(newRef); } },
        React.createElement("div", { className: 'accurityDetail__headerIcon' },
            React.createElement(AccurityIcon, { iconName: iconName, color: inverted ? 'light' : undefined })),
        title ? (React.createElement("div", { className: 'accurityDetail__headerTitle' }, title)) : null,
        children ? (React.createElement("div", { className: 'accurityDetail__headerField' }, children)) : null));
};
export default DetailHeader;
//# sourceMappingURL=DetailHeader.js.map